import { useFormik } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { CheckBoxGroup, CheckBoxItem } from 'views/mutual/checkBoxGroup';
import { Direction, MultiSelections } from 'views/mutual/inputRadio';
import { CardLabel, QuestionCard } from 'views/mutual/questionCard';
import {
  SelectAndTextAnswer,
  ISelectAndTextQuestion,
  IMultiSelectionQuestion,
  MultiSelectionAnswer,
} from 'views/pages/compatibilityCheck/hooks';
import { LabelValue } from 'views/templates/personalAccountOpen/common';

type MultiSelectionQuestionPageProps = {
  question: IMultiSelectionQuestion;
  initialAnswer: MultiSelectionAnswer | null;
  onSubmit: (answerValue: MultiSelectionAnswer) => void;
  backQuestion: () => void;
};

type MultiSelectionQuestionPageInput = {
  answer: {
    value: number;
    label: string;
  } | null;
};

const validate = (input: MultiSelectionQuestionPageInput) => {
  const errors = {} as { [P in keyof MultiSelectionQuestionPageInput]: string | undefined };
  if (!input.answer) {
    errors.answer = '選択してください';
  }

  return errors;
};

export const MultiSelectionQuestionPage = (props: MultiSelectionQuestionPageProps) => {
  const [selected, setSelected] = useState<MultiSelectionAnswer | null>(props.initialAnswer);
  const [selectedError, setSelectedError] = useState<string>('');

  const validate = (selected: MultiSelectionAnswer | null) => {
    if (!selected) {
      setSelectedError('選択してください');
      return false;
    } else {
      setSelectedError('');
      return true;
    }
  };

  // 連続で使われる場合があるので質問が変わった場合に前の値が残らないように初期化
  useEffect(() => {
    setSelected(props.initialAnswer);
    setSelectedError('');
  }, [props.question, props.initialAnswer]);

  //戻った場合にもう一度読ませるなら、ここを使う
  // useEffect(() => {
  //   setReadFlag(false);
  // },[props.onSubmit])

  return (
    <div className="compatibilityCheck">
      <QuestionCard
        topChildren={<CardLabel letter={props.question.questionText} />}
        bottomChildren={
          <>
            <MultiSelections
              name={props.question.key}
              items={props.question.selections.map((x) => ({
                label: x.label,
                value: x,
              }))}
              selected={selected}
              onChange={(item: MultiSelectionAnswer) => {
                validate(item);
                setSelected(item);
              }}
              direction={Direction.row}
              error={selectedError || ''}
            />
          </>
        }
      />
      <div className="compatibilityCheck_buttons">
        <Button
          type={ButtonType.Submit}
          label="次へ"
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          onClick={() => {
            if (validate(selected)) {
              props.onSubmit(selected!);
            }
          }}
        />
        <Button
          label="前の画面に戻る"
          buttonFill={ButtonFill.link}
          buttonSize={ButtonSize.small}
          onClick={props.backQuestion}
        />
      </div>
    </div>
  );
};
